import {addCircleFilledSvg as Icon__small__addCircleFilledSvg} from '../Icon__small/Icon__small--addCircleFilled.js'

export var addCircleFilled = {
  name: 'addCircleFilled',
  category: 'icon',
  colorable: true,
  svg: Icon__small__addCircleFilledSvg,
};
